module.exports = __webpack_public_path__ + "static/media/Perro.8766b73f.gif";